import { render, staticRenderFns } from "./StepReviewStudents.vue?vue&type=template&id=31a8a95e"
import script from "./StepReviewStudents.vue?vue&type=script&lang=js"
export * from "./StepReviewStudents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports